import cx from 'classnames';

import { CancelSmall } from '../Icons';

interface Props {
  content: React.ReactNode;
  clearable?: boolean;
  onClick?: VoidFunction;
}

export const Counter = ({ content, onClick, clearable = false }: Props) => {
  const Component = clearable ? 'button' : 'span';

  return (
    <Component
      className="group relative flex h-4 min-w-4 items-center justify-center rounded-large bg-neutral-96 px-1 hover:bg-neutral-90 focus-visible:focus-outline"
      onClick={onClick}
    >
      <span className={cx({ 'group-hover:invisible group-focus:invisible': clearable }, 'block text-center text-neutral-20 body-7')}>
        {content}
      </span>
      {clearable && <CancelSmall className="invisible absolute inset-0 m-auto h-3 w-3 shrink-0 group-hover:visible group-focus:visible" />}
    </Component>
  );
};
